<template>
    <router-view />
</template>
<script>

export default {
  name: 'App',
  meta() {
    return {
      title: this.$store.state.metaTitle,
      meta:{
        description: {
          name: 'description', 
          content: this.$store.state.metaDescription 
        },
        ogDescription: {
          property: 'og:title',
          content: this.$store.state.metaDescription
        },
        ogUrl: {
          property: 'og:url',
          content: `https://partners.bankos.io`
        }
      } 
    }
  },
};
</script>
<style></style>
